import { getBrandConfig } from '@/lib/configuration/configuration';

import type { MainHeaderProps } from './Header';
import { Header } from './Header';
import { SimpleHeader } from './SimpleHeader';

export const HeaderFactory = (props: MainHeaderProps) => {
  const brandConfig = getBrandConfig();
  const isSimpleHeader = brandConfig.simpleHeader;
  return isSimpleHeader ? <SimpleHeader {...props} /> : <Header {...props} />;
};
